module.exports = __webpack_public_path__ + "07_hige_black.dbb9d6f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/07_hige_black.png
// module id = I5m/
// module chunks = 0